import * as React from 'react';
// import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container'

import './index.scss';
import logo from '../../../assets/images/logo.png';
import frame from '../../../assets/images/frame.png';

const Header = () => {
  return (
    <Navbar expand="lg" className="main-nav p-0">
      <img src={frame} alt="Gem Sparkle" className="position-absolute text-center h-50 w-auto" style={{ left: 0 }} />
      <img src={frame} alt="Gem Sparkle" className="position-absolute text-center h-50 w-auto" style={{ transform: "scale(-1, -1)", right: 0 }} />
      <Container className="d-block text-center my-4" style={{ maxWidth: '992px' }}>
        <Navbar.Brand href="/">
          <img className="logo" src={logo} alt="AAD Gems Booster Club" />
        </Navbar.Brand>
        <div>
          <h1 style={{ fontFamily: 'Sellena', fontSize: 60 }}>AAD Gems Booster Club</h1>
          <h4><em>Supporting the competition teams of<br/><a target="_blank" rel="noreferrer" href="https://allanasacademyofdance.com">Allana's Academy of Dance</a></em></h4>
        </div>
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link disabled href="/">Donate<br /><small>(coming soon)</small></Nav.Link>
            <Nav.Link href="/events">Events</Nav.Link>
          </Nav>
        </Navbar.Collapse> */}
      </Container>
    </Navbar>
  )
}

export default Header;
